import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminProfileDataService } from 'src/app/admin-profile-data.service';
import { EncryptionService } from 'src/app/encryption.service';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FooterMoreInfoComponent } from 'src/app/home/landing-root/footer-more-info/footer-more-info.component';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { OurAppsComponent } from 'src/app/home/about-root/our-apps/our-apps.component';
import { VendorService } from 'src/app/services/vendor.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  standalone: true,
  selector: 'app-vendor-registration',
  templateUrl: './vendor-registration.component.html',
  styleUrl: './vendor-registration.component.scss',
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatDatepickerModule, MatNativeDateModule, MatChipsModule, MatIconModule, HeaderLatestComponent, OurAppsComponent, FooterMoreInfoComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class VendorRegistrationComponent {
  [key: string]: any;
  constructor() {}

  initVendorRegistration() {}
}
